var React = require('react');

function BatteriesIncluded (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z","key":1})]);
}

BatteriesIncluded.displayName = "BatteriesIncluded";

BatteriesIncluded.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = BatteriesIncluded;

BatteriesIncluded.default = BatteriesIncluded;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/BatteriesIncluded.svg
// module id = 635
// module chunks = 168707334958949